<template>
  <v-app>
    <v-container fluid grid-list-md>
      <v-layout row>
        <v-flex xs12 sm4 offset-sm4>
          <v-card>
            <v-card-title>
              <span class="headline">Verifying email</span>
            </v-card-title>
            <v-progress-linear v-if="loading"
              indeterminate
              color="yellow darken-2"
            ></v-progress-linear>
            <v-card-text class="title">
              {{ output }}
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text :to="{name: 'login'}">Go Home</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>

    <error-snackbar v-model="errorText"></error-snackbar>
    </v-container>
  </v-app>
</template>

<script>
import ApiRequests from '@/api/ApiRequests'
import ErrorSnackbar from '@/components/ErrorSnackbar'

export default {
  components: {
    ErrorSnackbar
  },

  data () {
    return {
      errorText: '',
      loading: true,
      output: ''
    }
  },

  created () {
    ApiRequests.verifyEmail(this.$route.query.token).then(r => {
      this.errorText = 'Email updated'
      this.output = 'Email verified, please login with your new email'
      this.loading = false
    }).catch(e => {
      this.loading = false
      this.output = 'Email verification failed: ' + e.response.data
      this.errorText = 'Error verifying token: ' + e.response.data
    })
  },

  methods: {
  }
}
</script>
